import React from 'react';

const DeleteLeadModal = ({ open, onClose, onConfirm, target }) => (
  <div className={`modal-overlay ${open ? 'active' : ''}`} onClick={onClose} data-testid="delete-lead-modal">
    <div className="modal-box" onClick={e => e.stopPropagation()}>
      <div className="modal-icon danger">🗑</div>
      <div className="modal-title">Hapus Lead</div>
      <div className="modal-sub">Apakah kamu yakin ingin menghapus lead ini? Tindakan ini tidak dapat dibatalkan.</div>
      <div style={{ fontSize: '13px', color: 'var(--gold)', fontFamily: "'JetBrains Mono', monospace", margin: '16px 0 4px' }}>
        {target?.name}
      </div>
      <div style={{ fontSize: '11px', color: 'var(--text-muted)', fontFamily: "'JetBrains Mono'", marginBottom: '24px' }}>
        {target?.company}
      </div>
      <div className="modal-actions">
        <button className="btn-modal btn-cancel" onClick={onClose} data-testid="delete-lead-cancel">Batal</button>
        <button className="btn-modal btn-danger" onClick={onConfirm} data-testid="delete-lead-confirm">✕ Hapus</button>
      </div>
    </div>
  </div>
);

export default DeleteLeadModal;
